import CustomDropdown from "@/ui/external/components/accordian";
import {
  AddNewUser,
  CareerIcons,
  CertificateIcon,
  CoursesIcons,
  EmptySite,
  FormIcons,
  IndustryAlliesIcon,
  InvoiceIcon,
  JourneyIcon,
  MentorsIcons,
  MomentsIcons,
  PaymentIcon,
  PrivacyIcon,
  ResponseIcons,
  RoleAndPermission,
  SingleUser,
  SkillshikhyaIconWhite,
  SuccessStoryIcon,
  TeamMembers,
  TermsIcon,
  GiftBox,
} from "@assets/icons";
import {
  HelpCircle,
  MessageSquare,
  Newspaper,
  PaintBucket,
  Settings,
  Settings2,
  Link2,
} from "lucide-react";
import { Link, NavLink, useNavigate } from "react-router";
import "./index.css";
import { useUser } from "@utils/states/index.state";
interface SidebarProps {
  setShowSidebar: React.Dispatch<React.SetStateAction<boolean>>;
  showSidebar?: boolean;
}
const index = ({ setShowSidebar }: SidebarProps) => {
  const { user } = useUser();

  const { models_with_permission } = user;
  const hasPermission = (model: string) => {
    return models_with_permission?.some(
      (permission: { name: string }) => permission?.name === model,
    );
  };
  console.log(
    "ADASASDASDASDAS",
    hasPermission("enrollment") ||
      hasPermission("requestform") ||
      hasPermission("responseform") ||
      hasPermission("contactus"),
  );
  const sidebarData = [
    {
      title: "Main",
      children: [
        {
          label: "Journey",
          icon: <JourneyIcon className="active:text-[#1DA077]" />,
          allowed: hasPermission("journey"),
          path: "/journey",
        },
        {
          label: "Success Stories",
          icon: <SuccessStoryIcon className="active:text-[#1DA077]" />,
          allowed: hasPermission("successstory"),
          path: "/success-stories",
        },
        {
          label: "Moments",
          icon: <MomentsIcons className="active:text-[#1DA077]" />,
          path: "/moments",
          allowed: hasPermission("moments"),
        },
      ],
    },
    {
      title: "Partners & People",
      children: [
        {
          label: "Industry Allies",
          icon: <IndustryAlliesIcon className="active:text-[#1DA077]" />,
          path: "/industry-allies",
          allowed: hasPermission("industryallies"),
        },
        {
          label: "Mentors",
          icon: <MentorsIcons className="active:text-[#1DA077]" />,
          path: "/mentors",
          allowed: hasPermission("mentors"),
        },
      ],
    },
    {
      title: "Learning",
      children: [
        {
          label: "Courses",
          icon: <CoursesIcons className="active:text-[#1DA077]" />,
          path: "/courses",
          allowed: hasPermission("course"),

          subChildren: [
            {
              label: "Course",
              allowed: hasPermission("course"),

              path: "/courses",
            },
            {
              label: "Masterclass Course",
              allowed: hasPermission("course"),
              path: "/masterclass-courses",
            },
            {
              label: "SEE Course",
              allowed: hasPermission("course"),
              path: "/see-courses",
            },
            {
              label: "Plus 2 Course",
              allowed: hasPermission("course"),
              path: "/plus2-courses",
            },
            {
              label: "JRP Course",
              allowed: hasPermission("course"),
              path: "/jrp-courses",
            },
          ],
        },
        {
          label: "Careers",
          icon: <CareerIcons className="active:text-[#1DA077]" />,
          allowed: hasPermission("career"),
          path: "/careers",
        },
      ],
    },
    {
      title: "Community",
      children: [
        {
          label: "Testimonials",
          icon: <MessageSquare />,
          path: "/testimonials",
          allowed: hasPermission("testimonial"),
        },
        {
          label: "Enterprise Testimonials",
          icon: <MessageSquare />,
          path: "/enterprise-testimonials",
          allowed: hasPermission("enterprisetestimonial") || true,
        },
        {
          label: "Cherish Moments",
          icon: <MessageSquare />,
          path: "/enterprise-cherish-moments",
          allowed: hasPermission("enterprisecherishmoment") || true,
        },
        {
          label: "Home Cherish Moments",
          icon: <MessageSquare />,
          path: "/home-cherish-moments",
          allowed: true,
        },
        {
          label: "FAQs",
          icon: <HelpCircle />,
          path: "/faqs",
          allowed: hasPermission("faqs"),
        },
        {
          label: "Blogs",
          icon: <Newspaper />,
          path: "/blogs",
          allowed: hasPermission("blog"),
        },
        {
          label: "BlogsC",
          icon: <Newspaper />,
          path: "/blogsC",
          allowed: hasPermission("blog"),
        },
        {
          label: "Redirects",
          icon: <Link2 />,
          path: "/redirects",
          allowed: true,
        },
        {
          label: "Giveaway",
          icon: <GiftBox className="active:text-[#1DA077]" />,
          path: "/giveaway-templates",
          allowed: hasPermission("custompage"),
        },
      ],
    },
    {
      title: "Forms & Verifications",
      children: [
        {
          label: "Responses",
          icon: <ResponseIcons className="active:text-[#1DA077]" />,
          allowed:
            hasPermission("enrollment") ||
            hasPermission("requestform") ||
            hasPermission("responseform") ||
            hasPermission("contactus"),
          subChildren: [
            {
              label: "Enrollment",
              path: "/response/enrollment",
              allowed: hasPermission("enrollment"),
            },
            {
              label: "Masterclass Enrollment",
              path: "/response/masterclass-enrollment",
              allowed: hasPermission("enrollment"),
            },
            {
              label: "Giveaway Enrollment",
              // icon: <FileText />,
              allowed: true,
              path: "/response/giveaway",
            },
            {
              label: "Festival Enrollment",
              // icon: <FileText />,
              allowed: true,
              path: "/response/festival",
            },
            {
              label: "Request Form",
              allowed: hasPermission("requestform"),
              path: "/response/request-form",
            },
            {
              label: "Session Inquiry",
              allowed: true,
              path: "/response/session-inquiry",
            },
            {
              label: "Contact Form",
              // icon: <FileText />,
              allowed: hasPermission("contactus"),
              path: "/response/contact-form",
            },
          ],
        },
      ],
    },
    {
      title: "Certification",
      children: [
        {
          label: "Certification",
          icon: <CertificateIcon className="active:text-[#1DA077]" />,
          allowed: hasPermission("certificate"),

          subChildren: [
            {
              label: "Certificates",
              // icon: <LayoutTemplate />,
              allowed: hasPermission("certificate"),
              path: "/certificate/certificates",
            },
            {
              label: "Branding",
              // icon: <LayoutTemplate />,
              allowed: hasPermission("certificate"),
              path: "/certificate/branding",
            },
            {
              label: "Manage Template",
              allowed: hasPermission("certificate"),

              path: "/certificate/manage-template",
            },
            {
              label: "Chat Webhook",
              allowed: hasPermission("certificate"),
              path: "/certificate-webhook",
            },
          ],
        },
        {
          label: "Forms",
          allowed: hasPermission("forms"),
          icon: <FormIcons className="active:text-[#1DA077]" />,
          path: "/forms",
        },
      ],
    },
    {
      title: "Management",
      children: [
        {
          label: "Team Members",
          allowed: hasPermission("teammember"),
          icon: <TeamMembers className="active:text-[#1DA077]" />,
          path: "/team-members",
        },
        {
          label: "Microsoft Teams",
          // allowed: hasPermission("microsoft-teams"),
          allowed: true,
          icon: <RoleAndPermission className="active:text-[#1DA077]" />,
          path: "/microsoft-teams",
        },
        {
          label: "Students",
          allowed: hasPermission("student"),
          icon: <SingleUser className="active:text-[#1DA077]" />,

          subChildren: [
            {
              label: "Students",
              allowed: hasPermission("student"),
              path: "/students",
            },
            {
              label: "Masterclass Students",
              allowed: hasPermission("student"),
              path: "/masterclass-students",
            },
          ],
        },
        {
          label: "Student Placement",
          allowed: hasPermission("studentplacement"),

          icon: <AddNewUser className="active:text-[#1DA077]" />,
          path: "/student-placement",
        },
        {
          label: "Staff Activity Log",
          allowed: true,

          icon: <TeamMembers className="active:text-[#1DA077]" />,
          path: "/activity-log",
        },
        {
          label: "Role & Access",
          allowed: hasPermission("group"),

          icon: <RoleAndPermission className="active:text-[#1DA077]" />,
          path: "/roles-&-access",
        },
        {
          label: "Site Settings",
          allowed: hasPermission("group"),

          icon: <Settings2 />,
          path: "/site-settings",
        },
      ],
    },
    {
      title: "Content",
      children: [
        {
          label: "Cricket Event",
          // allowed: hasPermission("cricket-event"),
          allowed: true,
          icon: <Settings className="active:text-[#1DA077]" />,

          subChildren: [
            {
              label: "Matches",
              allowed: hasPermission("invoice"),
              icon: <InvoiceIcon className="active:text-[#1DA077]" />,
              path: "/cricket-match",
            },
            {
              label: "Teams",
              allowed: hasPermission("invoice"),
              icon: <InvoiceIcon className="active:text-[#1DA077]" />,
              path: "/cricket-teams",
            },
            {
              label: "User Predictions",
              allowed: hasPermission("invoice"),
              icon: <InvoiceIcon className="active:text-[#1DA077]" />,
              path: "/cricket-predictions",
            },
            {
              label: "User Details",
              allowed: hasPermission("invoice"),
              icon: <InvoiceIcon className="active:text-[#1DA077]" />,
              path: "/cricket-userdetails",
            },
          ],
        },
      ],
    },
    {
      title: "Payment",
      children: [
        {
          label: "Invoice",
          allowed: hasPermission("invoice"),

          icon: <InvoiceIcon className="active:text-[#1DA077]" />,

          subChildren: [
            {
              label: "Invoice",
              allowed: hasPermission("invoice"),
              // icon: <LayoutTemplate />,
              path: "/invoice",
            },
            {
              label: "Masterclass Invoice",
              // icon: <LayoutTemplate />,
              path: "/masterclass-invoice",
              allowed: hasPermission("invoice"),
            },
            {
              label: "JRP Invoice",
              // icon: <LayoutTemplate />,
              path: "/jrp-invoice",
              allowed: hasPermission("invoice"),
            },
          ],
        },
        {
          label: "Payment",
          icon: <PaymentIcon className="active:text-[#1DA077]" />,
          path: "/payment",
          allowed: hasPermission("payment"),

          subChildren: [
            {
              label: "Payment",
              allowed: hasPermission("payment"),
              // icon: <LayoutTemplate />,
              path: "/payment",
            },
            {
              label: "Masterclass Payment",
              allowed: hasPermission("payment"),
              // icon: <LayoutTemplate />,
              path: "/masterclass-payment",
            },
            {
              label: "JRP Payment",
              allowed: hasPermission("payment"),
              // icon: <LayoutTemplate />,
              path: "/jrp-payment",
            },
          ],
        },
      ],
    },
    {
      title: "Site Management",
      children: [
        {
          label: "Custom Page",
          allowed: hasPermission("custompage"),

          icon: <EmptySite className="active:text-[#1DA077]" />,
          path: "/custom-page",
        },
        {
          label: "Bucket",
          allowed: true,
          icon: <PaintBucket className="active:text-[#1DA077]" />,
          path: "/bucket",
        },
        {
          label: "Privacy Policy",
          allowed: hasPermission("privacypolicy"),

          icon: <PrivacyIcon className="active:text-[#1DA077]" />,
          path: "/privacy-policy",
        },
        {
          label: "Terms & Conditions",
          allowed: hasPermission("termsconditions"),

          icon: <TermsIcon className="active:text-[#1DA077]" />,
          path: "/terms-&-condition",
        },
      ],
    },
    {
      title: "Ads Management",
      children: [
        {
          label: "Advertisments",
          icon: <CertificateIcon className="active:text-[#1DA077]" />,
          allowed: true,

          subChildren: [
            {
              label: "Popup Ads",
              // allowed: hasPermission("certificate"),
              allowed: true,
              path: "/advertisment/popup",
            },
          ],
        },
      ],
    },
  ];
  const navigate = useNavigate();

  return (
    <aside className="bg-[#1A926C]    overflow-auto  relative w-[266px] scrollbar-hidden text-[#FAFAFA] rounded-[10px]  h-[91vh] ">
      <div className=" ">
        <span
          onClick={() => {
            navigate("/journey");
          }}
          className="sticky top-0 w-full left-0 cursor-pointer  z-50 bg-[#1A926C]  h-[60px] flex items-center justify-center"
        >
          <SkillshikhyaIconWhite />
        </span>
        <div className="px-[12px] py-[20px]">
          {" "}
          {sidebarData.map((item, index) => (
            <div key={index} className="">
              {item?.children?.some((child) => child.allowed) && (
                <span className="text-[#B9E2D5] mt-4 block capitalize text-[12px] font-medium">
                  {item.title}
                </span>
              )}
              <ul className="">
                {item.children.map(
                  (child, childIndex) =>
                    child.allowed && (
                      <li key={childIndex}>
                        {child.subChildren ? (
                          <>
                            <CustomDropdown
                              title={child?.label}
                              data={child.subChildren}
                              icon={child.icon}
                              allowed={child.allowed}
                            />
                          </>
                        ) : (
                          <NavLink
                            to={child.path || ""}
                            onClick={() => {
                              setShowSidebar(false);
                            }}
                            className="flex gap-4 mt-4  capitalize navlink p-[10px] transition-colors hover:bg-white rounded-[4px] hover:text-[#1A926C] font-medium "
                          >
                            {child.icon}
                            {child.label}
                          </NavLink>
                        )}
                      </li>
                    ),
                )}
              </ul>
            </div>
          ))}
        </div>

        <span className="text-sm text-center block mt-4">
          {" "}
          &copy; {new Date().getFullYear()}{" "}
          <Link
            to={"https://vrittechnologies.com/"}
            target="_blank"
            className="cursor-pointer"
          >
            Vrit Technologies
          </Link>
        </span>
      </div>
    </aside>
  );
};

export default index;
